import { IMessageOfferSchema } from '../../../repositories/cian-chat-bot/entities/offer/MessageOfferSchema';
import { IParsedMessage } from '../../../utils/messageUtils';

export const useMergeOfferMessages = (messages: IParsedMessage[]): { mergedMessages: IParsedMessage[] } => {
  return {
    mergedMessages: messages.reduce((acc: IParsedMessage[], current: IParsedMessage) => {
      const prev = acc[acc.length - 1];

      if (
        current.message.message === '' &&
        current.message.offers?.length === 1 &&
        !current.message.isOutcoming &&
        current.message.fromChatBot &&
        prev &&
        prev.message.message === '' &&
        (prev.message.offers?.length ?? 0) >= 1 &&
        !prev.message.isOutcoming &&
        prev.message.fromChatBot
      ) {
        const mergedOffers = (
          [...(prev.message.offers || []), ...(current.message.offers || [])] as IMessageOfferSchema[]
        ).sort((a, b) => {
          const posA = a.position ?? Infinity;
          const posB = b.position ?? Infinity;

          return posA - posB;
        });

        const updatedPrev = {
          ...prev,
          message: {
            ...prev.message,
            offers: mergedOffers,
            animation: prev.message.animation || current.message.animation,
          },
        };
        acc[acc.length - 1] = updatedPrev as IParsedMessage;
      } else {
        acc.push({ ...current });
      }

      return acc;
    }, []),
  };
};
